import * as R from 'ramda'

const notEmpty = R.complement(R.isEmpty)

const notNil = R.complement(R.isNil)

const notNilOrEmpty = R.complement(R.either(R.isNil, R.isEmpty))

const notEquals = R.curry((a, b) => R.complement(R.equals(a))(b))

const nilOrEmpty = R.either(R.isNil, R.isEmpty)

const mapIndexed = R.addIndex(R.map)

const shuffler = R.curry(function(random, list) {
  var idx = -1
  var len = list.length
  var position
  var result = []
  while (++idx < len) {
    position = Math.floor((idx + 1) * random())
    result[idx] = result[position]
    result[position] = list[idx]
  }
  return result
})

const shuffle = shuffler(Math.random)

const findIndex = (arr, val) => R.findIndex(R.propEq('_id', val))(arr)

const getYoutubeUrlId = R.cond([
  [R.startsWith('https://youtu'), (val) => R.slice(-11, Infinity, val)],
  [
    R.startsWith('https://www.youtube'),
    (val) => R.compose(R.head, (e) => R.split('&', e[1]), R.split('='))(val)
  ],
  [R.T, (val) => val]
])

export function isValidURL(string) {
  var res = string.match(
    /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
  )
  return res !== null
}

export function randomRangeNum(min, max) {
  return Math.random() * (max - min) + min
}

export function rangeFloor(min, max) {
  // Return a random whole number between min and max
  return Math.floor(Math.random() * (max - min) + min)
}

export function pick(array) {
  // Pick a random item out of an array
  if (array.length === 0) return undefined
  return array[rangeFloor(0, array.length)]
}

export {
  findIndex,
  getYoutubeUrlId,
  mapIndexed,
  nilOrEmpty,
  notEmpty,
  notEquals,
  notNil,
  notNilOrEmpty,
  shuffle
}
